module.exports = __webpack_public_path__ + "static/media/OBESIDADE.3de92ece.png";